<template>
  <BlackoutPeriodForm @submit="onSubmit($event)" @submit-recurring="onSubmitRecurring($event)" />
</template>

<script>
  import BlackoutPeriodService from '../services/blackout-period.service';
  import BlackoutPeriodForm from './BlackoutPeriodForm';
  export default {
    name: 'BlackoutPeriodAdd',
    components: {
      BlackoutPeriodForm
    },
    methods: {
      async onSubmit(body) {
        try {
          await BlackoutPeriodService.create(body);
          this.$showSuccessMessage('Added Blackout period');
          this.$router.push('/blackout-periods/list');
        } catch (error) {
          this.$showMultiErrorMessage(error.messages || []);
        }
      },
      async onSubmitRecurring(body) {
        try {
          await BlackoutPeriodService.createRecurring(body);
          this.$showSuccessMessage('Added recurring Blackout period');
          this.$router.push('/blackout-periods/list');
        } catch (error) {
          this.$showMultiErrorMessage(error.messages || []);
        }
      }
    }
  };
</script>

<style lang="scss" scoped></style>
